const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const API_URL = `${BASE_URL}/home/info`;
export const PREVIEW_URL = `${BASE_URL}/project`;
